import { connect } from 'react-redux';

import {
  onShowChooseAddress as loadChooseAddress,
  reportChangeAddressClick,
} from 'redux/modules/address/actions';
import { getAddressChosenFromModal } from 'redux/modules/address/selectors';

import ChooseAddress from 'components/Address/ChooseAddress/ChooseAddress';

const mapStateToProps = state => ({
  addressChosenFromModal: getAddressChosenFromModal(state),
});

export default connect(mapStateToProps, {
  loadChooseAddress,
  reportChangeAddressClick,
})(ChooseAddress);
